// Session version management
// Tracks session format versions for backward compatibility

export const SESSION_VERSION = '2.0'
export const TOOL_SCHEMA_VERSION = '2.0'
export const TOOL_ARCHITECTURE = 'single' // 'multi' or 'single'

// Version history
export const VERSION_HISTORY = {
  '1.0': {
    toolArchitecture: 'multi',
    tools: ['searchNotes', 'saveNote', 'listNotes', 'updateNote', 'deleteNote', 'fetch', 'webSearch'],
    deprecated: true,
    migrationPath: '2.0',
    description: 'Multi-tool architecture with direct tool exposure to LLM',
  },
  '2.0': {
    toolArchitecture: 'single',
    tools: ['executeCode'],
    current: true,
    description: 'Single executeCode tool wrapping all other tools',
  },
}

/**
 * Check if migration is needed
 * @param {Object} sessionMetadata - Session metadata object
 * @returns {boolean} True if migration is needed
 */
export const needsMigration = (sessionMetadata) => {
  // No metadata or no version field means v1.0 (old format)
  if (!sessionMetadata || !sessionMetadata.version) {
    return true
  }

  const sessionVersion = sessionMetadata.version
  return sessionVersion !== SESSION_VERSION
}

/**
 * Get migration path for a version
 * @param {string} fromVersion - Source version
 * @returns {string|null} Target version or null if no path
 */
export const getMigrationPath = (fromVersion) => {
  const versionInfo = VERSION_HISTORY[fromVersion]
  return versionInfo?.migrationPath || null
}

/**
 * Get version info
 * @param {string} version - Version number
 * @returns {Object|null} Version information or null
 */
export const getVersionInfo = (version) => {
  return VERSION_HISTORY[version] || null
}

/**
 * Check if a version is deprecated
 * @param {string} version - Version number
 * @returns {boolean} True if deprecated
 */
export const isDeprecated = (version) => {
  const versionInfo = VERSION_HISTORY[version]
  return versionInfo?.deprecated === true
}
